// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3iqQp","title":"card_title__1xZY8","inActive":"card_inActive__5EUpV"};